import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralServiceService } from 'src/app/services/general-service.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ModalSchedaProdComponent } from '../modal-scheda-prod/modal-scheda-prod.component';

@Component({
  selector: 'app-scheda-prodotto',
  templateUrl: './scheda-prodotto.component.html',
  styleUrls: ['./scheda-prodotto.component.scss']
})
export class SchedaProdottoComponent implements OnInit {
  @Output() childEvent = new EventEmitter();
  @Input() idProdotto: any[] = [];
  //idProdotto: any;
  datiProdotto: any=[];
  qty: any = 1;
  listaProdottiCorrelati: any[] = [];
  titoloProd : any = "";
  loggato: boolean = false;
  estero: any;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, public genericFunc: GeneralServiceService, public toastr: ToastrService,
    private local: LocalStorageService) { }

  ngOnInit(): void {


    this.estero = this.genericFunc.estero;

    //this.loggato = this.genericFunc.loggato;

    //this.idProdotto = this.activatedRoute.snapshot.paramMap.get('idProdotto');
    //this.getDatiProdotto();
    this.activatedRoute.paramMap.subscribe(params => {
      //this.idProdotto = params.get("idProdotto");

      if (this.local.getLocal('username') != "" && this.local.getLocal('username') != null && this.local.getLocal('username') != 'null') {
        let datiLogin = {func: 'checkToken', token: this.local.getLocal('token'), idut: this.local.getLocal('idut'), deviceId: ''}
        this.genericFunc.genericFunction(datiLogin).subscribe( response => {
          console.log(response);
          if (response.login == 1) {
            this.genericFunc.currentUser = response;
            console.log(this.genericFunc.currentUser);
            this.genericFunc.currentToken = response['token'];
            this.genericFunc.idCart = response['idcar'];
            this.genericFunc.totCart = response.TotProdCar;
            this.genericFunc.minimoOrd = response.MinimoOrd;
            this.genericFunc.changeItemCart(response.TotProdCar);
            
            
            this.genericFunc.changeLoggato(true);
            this.genericFunc.changeCurrentUser(response);
            this.loggato = true;
            this.getDatiProdotto(this.idProdotto);

            
          } else {
            this.genericFunc.loggato = false;
            this.genericFunc.currentToken = '';
            this.genericFunc.idCart = '';
            //this.router.navigateByUrl('accedi');
            this.genericFunc.changeLoggato(false);
            
            this.getDatiProdotto(this.idProdotto);
            this.loggato = this.genericFunc.loggato;
          }
        });
      } else {
        this.getDatiProdotto(this.idProdotto);
        this.genericFunc.subjectLoggato.subscribe((loggatoNew: boolean) => {
          this.loggato = loggatoNew;
        });
      }
      
   })
    
  }

 

  ngAfterViewInit(): void {
   
    let top = document.getElementById('page-content');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
    //this.idProdotto = this.activatedRoute.snapshot.paramMap.get('idProdotto');
    console.log(this.idProdotto);
    this.getDatiProdotto(this.idProdotto);
    
  }

  getDatiProdotto(idProd) {
    this.idProdotto = idProd;
    console.log(idProd);
    let datiProdotto = {func: "SkProd", id: this.idProdotto, token: this.genericFunc.currentToken };

    this.genericFunc.genericFunction(datiProdotto).subscribe( response => {
      console.log(response);
      this.datiProdotto = response.skprod[0];
      //this.getCorrelati();
    });

  }

  getCorrelati() {
    let datiCorrelati = {func: "ProdCorr", idprod: this.idProdotto, idcat: this.datiProdotto.idcat, idut: this.genericFunc.currentUser.idut};
    this.genericFunc.genericFunction(datiCorrelati).subscribe(response => {
      this.listaProdottiCorrelati = response.skprod;
      for (let i = 0; i < this.listaProdottiCorrelati.length; i++) {
        this.listaProdottiCorrelati[i].qty = 1;
        
      }
    });
    
  }

  addQty() {
    this.qty = this.qty + 1;
  }

  removeQty() {
    if (this.qty > 1 ) {
      this.qty = this.qty - 1;
    }
  }

  addCart(prodotto) {
    let idProd: any;
    if (prodotto.InPromo != 0) {
      idProd = prodotto.InPromo;
    } else {
      idProd = prodotto.idprod;
    }
    let datiCart = {func: "aggCar", id: idProd, qta: this.qty, idcar: this.genericFunc.idCart, token: this.genericFunc.currentToken, idut: this.genericFunc.currentUser.idut};
    
    this.genericFunc.genericFunction(datiCart).subscribe(response => {
     console.log(response);
     if (response.Esito == "ok") {
       this.toastr.success("Proddo aggiunto al carrello");
       this.genericFunc.totCart = response.totProdCar;
       this.genericFunc.idCart = response.idcarrello;
       this.genericFunc.changeItemCart(response.totProdCar);
       this.childEvent.emit('close modal');
     } else {
       this.toastr.error(response.messaggio);
     }
    });
  }

}
